module.exports = __webpack_public_path__ + "media/images/offered-payment-plan-step-3-2a2958de.png";